/**
 * Class names, joined, with the falsy ones dropped.
 *
 * Deliberately not `tailwind-merge`: nothing here resolves conflicting
 * utilities, so a component that wants to be overridable puts the caller's
 * `className` last and keeps its own list free of the property being
 * overridden. That is a discipline rather than a guarantee, and it is the same
 * one the design system this came from uses.
 */
export function cn(...args: Array<string | false | null | undefined>): string {
  return args.filter(Boolean).join(' ');
}
